<template>
  <WidgetVue 
  :title="title"
  :desc="desc"
  >
    <div class="chart">
    
    <!-- <button @click="changeMetric">Change Metric</button> Bubble sizes by {{ active_metric }} -->
    <canvas ref="bubbleChartCanvas"></canvas>
   
  </div>
  </WidgetVue>
</template>
<script>
import { Chart } from "chart.js/auto";
import WidgetVue from "@/components/WidgetVue.vue"
export default {
  
  components:{
    WidgetVue
  },
  props: {
    desc: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
    bgColor: {
      type: String,
      required: true,
    },
    active_metric: {
      type: String,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    setTimeout(() => {
      this.prepareDataAndDrawChart();
    }, 100);
  },
  data() {
    return {
            msg: "ok",
    };
      
  },
  
  methods: {

   
    prepareDataAndDrawChart() {

      //head
      //get first 10 item of data
      const fdata = this.data.slice(0, 10);
   
      
      const ctx = this.$refs.bubbleChartCanvas.getContext("2d");

      const words = fdata.map(item => item.word);
      // const xValues = this.data.map(item => parseFloat(item.freq));
      const xValues = words
      const yValues = fdata.map(item => parseFloat(item.freq));
      const bubbleSizes = fdata.map(item => parseFloat(item[this.active_metric]/10));
      
      // console.log(words, xValues, yValues, bubbleSizes, ctx);

      

      new Chart(ctx, {
        type: "bubble",
        data: {
          labels: words,
          datasets: [
            {
              label: `Words`,
              data: words.map((word, index) => ({
                x: xValues[index],
                y: yValues[index],
                r: bubbleSizes[index],
              })),
             
              borderWidth: 1,
              backgroundColor: this.bgColor,
              borderColor: 'black'
            },
          ],
        },
        options: {
          scales: {
            x: {
              type: "category",
              position: "bottom",
              title: {
                display: true,
                text: 'Keyword',
              },
            },
            y: {
              type: "linear",
              title: {
                display: true,
                text: 'Frequency',
              },
              beginAtZero: true,
            },
          },
        },
      });
    },
  },
};
</script>
<style scoped>
/* Add your custom styles here if needed */

.desc{
    padding: 10px;
}
</style>
